import { Component, OnInit, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { MatTable } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';

import { AlertService } from '../core/alert/alert.service';
import { Billee } from '../model/billee';
import { BillingOptions } from '../model/billing-options';
import { BillingOptionsService } from '../services/billing-options.service';
import { PaymentPlan } from '../model/payment-plan';
import { SubmissionService } from '../services/submission.service';

@Component({
  selector: 'app-billing-form',
  templateUrl: './billing-form.component.html',
  styleUrls: ['./billing-form.component.css']
})
export class BillingFormComponent implements OnInit {
  private readonly INSURED = 'Insured';
  private readonly LIENHOLDER = 'Lienholder';
  private readonly MAILING_ADDRESS = 'MailingAddress';
  private readonly PAY_IN_FULL = 'PAY IN FULL';

  @ViewChild('paymentPlanTable', {static: false}) paymentPlanTable: MatTable<any>;
  billeeColumns = ['select', 'name', 'type', 'address'];
  billeeSelection = new SelectionModel<Billee>(false, []);
  billingOptions: BillingOptions;
  canSubmitWithoutPayment = false;
  canSubmitWithPayment = false;
  paymentPlanColumns = ['select', 'name', 'description', 'downPayment', 'installment', 'numberOfInstallments', 'installFee', 'netDue'];
  paymentPlanSelection = new SelectionModel<PaymentPlan>(false, []);

  constructor(private alertService: AlertService,
              private billingOptionsService: BillingOptionsService,
              private router: Router,
              private submissionService: SubmissionService) {
  }

  ngOnInit() {
    this.billingOptions = new BillingOptions();
    this.getBillingOptions();
    const billee = this.billingOptionsService.getSelectedBillee();
    const paymentPlan = this.billingOptionsService.getSelectedPaymentPlan();
    if (billee) {
      this.billeeSelection.select(billee);
    }
    if (paymentPlan) {
      this.paymentPlanSelection.select(paymentPlan);
    }
    this.updateCanSubmit();
  }

  getBillingOptions(): void {
    this.billingOptionsService.getBillingOptions()
        .subscribe(billingOptions => {
          this.billingOptions = billingOptions;
          this.billingOptionsService.setBillingOptions(billingOptions);
          this.billingOptionsService.setPolicyNumber(billingOptions.policyNumber);
        });
  }

  isDisabled(paymentPlan: PaymentPlan): boolean {
    if (paymentPlan.name === this.PAY_IN_FULL) {
      return false;
    }
    return this.billeeSelection.hasValue() && this.billeeSelection.selected[0].type === this.LIENHOLDER;
  }

  onBilleeChange(billee: Billee) {
    this.billeeSelection.select(billee);
    this.updateCanSubmit();
    if (billee.type === this.LIENHOLDER) {
      this.selectPayInFull();
    }
    this.billingOptionsService.setSelectedBillee(billee);
    this.paymentPlanTable.renderRows();
  }

  onPaymentPlanChange(paymentPlan: PaymentPlan) {
    if (this.isDisabled(paymentPlan)) {
      return;
    }
    this.paymentPlanSelection.select(paymentPlan);
    this.billingOptionsService.setSelectedPaymentPlan(paymentPlan);
    this.updateCanSubmit();
  }

  selectPayInFull() {
    this.onPaymentPlanChange(
        this.billingOptions.paymentPlans.find(p => p.name === this.PAY_IN_FULL)
    );
  }

  submitWithoutPayment() {
    this.submissionService.submitWithoutPayment(this.billeeSelection.selected[0].id, this.PAY_IN_FULL)
        .subscribe(res => {
          if (res.success) {
            // noinspection JSIgnoredPromiseFromCall
            this.router.navigateByUrl('/success');
          } else {
            this.alertService.error(res.errors.join('\n'));
          }
        });
  }

  updateCanSubmit() {
    const canSubmit: boolean = this.billeeSelection.hasValue() && this.paymentPlanSelection.hasValue();

    const selectedBilleeType = this.billeeSelection.selected[0].type;

    this.canSubmitWithPayment = canSubmit &&
        (selectedBilleeType === this.INSURED || selectedBilleeType === this.MAILING_ADDRESS);
    this.canSubmitWithoutPayment = canSubmit && selectedBilleeType === this.LIENHOLDER;
  }

}
